import { Fragment, useState, useEffect } from "react";

function TodaysDate() {

    const getFormattedDate = () => {
        const today = new Date();

        // Options for formatting the date
        const options = { weekday: 'long', month: 'long', day: 'numeric' };

        // Format the date
        return today.toLocaleDateString('en-US', options);
    };

    const getFormattedTime = () => {
        const now = new Date();
        const options = { hour: '2-digit', minute: '2-digit' };
        return now.toLocaleTimeString('en-US', options);
    };

    const [time, setTime] = useState(getFormattedTime());

    useEffect(() => {
        const intervalId = setInterval(() => {
            setTime(getFormattedTime());
        },  60000); 

        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    return (
        <div className="el-topbar-right">
            <div className="el-topbar-date">
                <i className="el-icon-deadline"></i>
                <span><small>{getFormattedDate()}</small><br />{time}</span>
            </div>
            <div className="el-topbar-weather">
                <i className="el-icon-rainy-day"></i>
                <span>Sunny<br />36°</span>
            </div>
        </div>
    );
}

export default TodaysDate;
